/* Load Modules */
import { memoize } from "lodash";

/* Load Constants */
import {
    checkRenderForProvider,
    checkDefaultForType
} from "../../../../../../../utils/utils";

export const defaultValues = memoize(({ schema }) => {
    let defaults = {};

    Object.keys(schema.properties).map(item => {
        defaults[item] =
            checkRenderForProvider(item, schema.properties) &&
            schema.properties[item]
                ? schema.properties[item].hasOwnProperty("default")
                    ? schema.properties[item].convert
                        ? schema.properties[item].default / 100
                        : schema.properties[item].default
                    : checkDefaultForType(schema.properties[item].type)
                : null;
    });

    return defaults;
});
